import {Image} from './image';
import {Video} from './video';
export class Ad {
  id: number;
  type: string;
  displayName: string;
  parentObjectName: string;
  shouldTrack: boolean;
  image: Image;
  video: Video;

  static fromJSON(json: AdJSON): Ad {
    const ad = Object.create(Ad.prototype);

    if (json.image && json.video) {
      return Object.assign(ad, json, {
        image: Image.fromJSON(JSON.parse(json.image)),
        video: Video.fromJSON(JSON.parse(json.video))
      });

    } else if (json.image) {
      return Object.assign(ad, json, {
        image: Image.fromJSON(JSON.parse(json.image))
      });
    }
  }

  toJSON(): AdJSON {
    return Object.assign({}, this, {
      image: JSON.stringify(this.image),
      video: JSON.stringify(this.video)
    });
  }

  constructor(public data: any) {
    const json: JSON = data;

    this.id = json['id'];
    this.displayName = json['advertiserName'];
    this.type = json['displayType'];
    this.shouldTrack = json['trackAnalytics'];

    if (json['images']) {
      if (json['images']['large']) {
        this.image = new Image(json['images']['large']);
      } else if (json['images']['small']) {
        this.image = new Image(json['images']['small']);
      }
    }

    if (json['video']) {
      this.video = new Video(json['video']);
    }
  }
}

interface AdJSON {
  id: number;
  type: string;
  displayName: string;
  parentObjectName: string;
  shouldTrack: boolean;
  image: string;
  video: string;
}



// WEBPACK FOOTER //
// ./src/app/model/ad.ts